module.exports = __webpack_public_path__ + "img/Logo_Simple_IBRACO.d6519330.svg";